<div class="sponsor-strip">
  <app-img-format
    class="sponsor-img sponsor-{{ sponsorStrip.sponsorImageOrientation }}"
    *ngIf="sponsorStrip?.sponsorImageUrl"
    [src]="sponsorStrip?.sponsorImageUrl"
    [alt]="sponsorStrip?.name"
    [aspectRatio]="'16:9'"
    [disableLazyLoad]="true"></app-img-format>
  <p
    class="sponsor-strip-text"
    *ngIf="sponsorStrip?.blurb"
    [innerHtml]="sponsorStrip.blurb"></p>
  <ion-button
    class="sponsor-strip-btn"
    (click)="goToUrl()"
    color="tertiary"
    fill="clear">
    {{ sponsorStrip.cta }}
  </ion-button>
</div>
